import ErrorBoundary from '@/components/ErrorBoundary';
import { LabradorComponent, StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { withDebugMetadata } from 'lib/utils';
import { Heading, HeadingProps } from './Heading';

export interface StandaloneHeadingProps extends StandaloneComponentProps {
  content?: string;
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  options?: HeadingProps;
}

export const StandaloneHeading: StandaloneComponent<StandaloneHeadingProps> = ({ content, tag, options, ...props }) => {
  return (
    <ErrorBoundary>
      <Heading content={content} tag={tag} {...options} {...props} />
    </ErrorBoundary>
  );
};

const LabradorHeading: LabradorComponent = ({ type, data, meta, descendants }) => {
  return (
    <StandaloneHeading
      content={data.content}
      tag={data.tag}
      options={{
        options: {
          className: meta.className,
        },
      }}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export const standalone = StandaloneHeading;

export default LabradorHeading;
